import * as React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Spinner from '../../components/Spinner';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { login } from 'features/userSlice';

function Copyright(props) {
    return (
        <Typography variant='body2' color='text.secondary' align='center' {...props}>
            {'Copyright © '}
            Layway {new Date().getFullYear()}.
        </Typography>
    );
}

const theme = createTheme();

export default function SignIn() {
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [otp, setOtp] = React.useState('');
    const [signingIn, setSigningIn] = React.useState(false);
    const [userId, setUserId] = React.useState('');
    const [otpDialogOpen, setOtpDialogOpen] = React.useState(false);
    const [verifying, setVerifying] = React.useState(false);
    const [resending, setResending] = React.useState(false);
    const dispatch = useDispatch();

    const handleLogin = (e) => {
        e.preventDefault();
        if (!email || !password) {
            alert('Email and password are both required');
            return;
        }

        setSigningIn(true);
        axios
            .post(`${API_BASE_URL}/admin/login`, { email, password })
            .then((res) => {
                if (res.data.requiresOTP === false && res.data.token) {
                    // OTP disabled or device already registered - log in directly
                    const user = {
                        id: res.data.user.id,
                        email: res.data.user.email,
                        name: res.data.user.name,
                        token: res.data.token,
                        role: res.data.user.role
                    };
                    localStorage.setItem('token', res.data.token);
                    localStorage.setItem('user', JSON.stringify(user));
                    dispatch(login(user));
                    return;
                }
                setUserId(res.data.userId);
                setOtpDialogOpen(true); // Open OTP dialog
            })
            .catch((err) => {
                alert(err.response?.data?.message || 'Failed to login');
            })
            .finally(() => setSigningIn(false));
    };

    const handleResendOtp = () => {
        if (!userId) {
            alert('Session expired. Please login again.');
            return;
        }

        setResending(true);
        axios
            .post(`${API_BASE_URL}/admin/resend-otp`, {
                userId
                // Backend will send to email (and SMS if enabled)
            })
            .then((res) => {
                alert('New OTP sent to your email address');
            })
            .catch((err) => {
                console.error('Resend OTP Error:', err.response?.data || err.message);
                alert(err.response?.data?.message || 'Failed to resend OTP');
            })
            .finally(() => setResending(false));
    };

    const handleVerifyOtp = () => {
        if (!otp) {
            alert('Please enter the OTP');
            return;
        }

        setVerifying(true); // Start spinner
        axios
            .post(`${API_BASE_URL}/admin/verify-otp`, { userId, otp })
            .then((res) => {
                console.log('Verification Success:', res.data);
                const user = {
                    id: res.data.user.id,
                    email: res.data.user.email, // Use email from response
                    name: res.data.user.name, // Store name as well
                    token: res.data.token,
                    role: res.data.user.role
                };
                localStorage.setItem('token', res.data.token);
                localStorage.setItem('user', JSON.stringify(user)); // Store full user data
                dispatch(login(user));
                setOtpDialogOpen(false); // Close OTP dialog
            })
            .catch((err) => {
                console.error('Verification Error:', err.response?.data || err.message);
                alert(err.response?.data?.message || 'Failed to verify OTP');
            })
            .finally(() => setVerifying(false)); // Stop spinner
    };

    return (
        <ThemeProvider theme={theme}>
            <Box
                sx={{
                    minHeight: '100vh',
                    width: '100%',
                    backgroundImage: 'url(/adl-bg_1.jpg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '5px',
                    '::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 40, 0, 0.5)'
                    }
                }}
            >
                <Container
                    component='main'
                    maxWidth='xs'
                    sx={{
                        position: 'relative',
                        zIndex: 1,
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        borderRadius: '12px',
                        /* padding: '40px', */
                        boxShadow: 3
                    }}
                >
                    <CssBaseline />
                    <Box
                        sx={{
                            marginTop: 8,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                        }}
                    >
                        <Box sx={{ m: 1, width: 80, height: 80, marginBottom: 5 }}>
                            <img
                                src='/Black logo - no background.png'
                                alt='Logo'
                                style={{ width: '100%' }}
                            />
                        </Box>
                        {/* <Typography component="h1" variant="h5"
            sx={{
              color: '#f0f0f0',
            }}
          >
            Sign in
          </Typography> */}
                        <Box component='form' onSubmit={handleLogin} noValidate sx={{ mt: 1 }}>
                            <TextField
                                margin='normal'
                                required
                                fullWidth
                                value={email}
                                label='Email Address'
                                name='email'
                                autoComplete='email'
                                autoFocus
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <TextField
                                margin='normal'
                                required
                                fullWidth
                                name='password'
                                value={password}
                                label='Password'
                                type='password'
                                autoComplete='current-password'
                                onChange={(e) => setPassword(e.target.value)}
                            />

                            <Button
                                type='submit'
                                fullWidth
                                variant='contained'
                                sx={{
                                    mt: 3,
                                    mb: 2,
                                    backgroundColor: '#085d40'
                                }}
                            >
                                {signingIn ? <Spinner /> : 'Sign In'}
                            </Button>
                        </Box>
                    </Box>
                    <Copyright sx={{ mt: 8, mb: 4 }} />

                    {/* OTP Verification Dialog */}
                    <Dialog
                        open={otpDialogOpen}
                        onClose={() => setOtpDialogOpen(false)}
                        maxWidth='sm'
                        fullWidth
                    >
                        <DialogTitle>
                            <Typography variant='h6' component='h2' gutterBottom>
                                Verify OTP
                            </Typography>
                            <Typography variant='body2' color='text.secondary' sx={{ mb: 1 }}>
                                A 6-digit code has been sent to your email address
                            </Typography>
                            {/* <Chip
                                label='📧 Email Delivery'
                                size='small'
                                color='primary'
                                sx={{ mt: 1 }}
                            /> */}
                        </DialogTitle>
                        <DialogContent>
                            <TextField
                                autoFocus
                                margin='dense'
                                label='Enter 6-digit OTP'
                                fullWidth
                                variant='outlined'
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                                inputProps={{ maxLength: 6, pattern: '[0-9]*' }}
                                sx={{ mb: 2 }}
                            />

                            <Typography variant='body2' color='text.secondary' gutterBottom>
                                Didn't receive the code?
                            </Typography>

                            <Button
                                size='small'
                                variant='outlined'
                                onClick={handleResendOtp}
                                disabled={resending || verifying}
                                startIcon={resending ? <Spinner size='small' /> : null}
                                sx={{ mt: 1 }}
                            >
                                {resending ? 'Sending...' : '📧 Resend Code'}
                            </Button>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOtpDialogOpen(false)} disabled={verifying}>
                                Cancel
                            </Button>
                            <Button
                                onClick={handleVerifyOtp}
                                disabled={verifying || !otp || otp.length !== 6}
                                variant='contained'
                            >
                                {verifying ? <Spinner size='small' /> : 'Verify OTP'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Container>
            </Box>
        </ThemeProvider>
    );
}
